import resourceConfig from '../config';

export default {
  resources: {
    [resourceConfig.name]: {
      enums: {
        PAYMENT_AFTER_APPLYING: 'Оплата по нанесению',
        PAYMENT_AFTER_EMISSION: 'Оплата по эмиссии',
      },
    }
  }
}
